/**
 * Check if dates are on the same day
 * @param {Date} d1
 * @param {Date} d2
 * @returns {boolean} Returns true if same day or false otherwise
 */
const isSameDay = (d1, d2) => {
  return (
    d1.getUTCDate() === d2.getUTCDate() &&
    d1.getUTCMonth() === d2.getUTCMonth() &&
    d1.getUTCFullYear() === d2.getUTCFullYear()
  )
}

module.exports = isSameDay
